import orderBy from "lodash/orderBy"
import get from "lodash/get"
import { Sort } from "../factory/types"

export function sortItems<T>(list: T[], sort: Sort | null): T[] {
  if (!sort?.key) return list

  // Small helper to extract sortable values
  const extract = (item: any, key: string | null | undefined) => {
    if (!key) return undefined
    const value = get(item, key) // support "a.b.c"

    if (value == null) return value

    if (value instanceof Date) return value.getTime()

    const num = Number(value)
    if (!Number.isNaN(num) && value !== "") return num

    const date = Date.parse(value as any)
    if (!Number.isNaN(date)) return date

    return value
  }

  const primaryKey = (item: T) => extract(item, sort.key!)
  const secondaryKey = (item: T) => extract(item, sort.keySecondary) ?? undefined

  return orderBy(
    list,
    [
      primaryKey,
      secondaryKey,
      "id" // third-level fallback
    ],
    [sort.asc ? "asc" : "desc", sort.keySecondary ? (sort.ascSecondary ? "asc" : "desc") : "asc", "asc"]
  )
}
